import { render, staticRenderFns } from "./mob-page-1.vue?vue&type=template&id=030c560e&scoped=true"
import script from "./mob-page-1.vue?vue&type=script&lang=js"
export * from "./mob-page-1.vue?vue&type=script&lang=js"
import style0 from "./mob-page-1.vue?vue&type=style&index=0&id=030c560e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c560e",
  null
  
)

export default component.exports